import { meshPickTargetsAtom } from '@/atoms';
import { useSetAtom } from 'jotai';
import { ReactNode, useEffect, useRef } from 'react';
import * as THREE from 'three';

/**
 * A <group> wrapper that registers itself with meshPickTargetsAtom
 * so measuring tools can raycast against it.
 */
const PickableGroup = ({ children, position }: { children: ReactNode; position: THREE.Vector3 }) => {
  const ref = useRef<THREE.Group>(null);
  const setTargets = useSetAtom(meshPickTargetsAtom);

  useEffect(() => {
    const group = ref.current;
    if (!group) return;
    setTargets((prev) => [...prev, group]);
    return () => setTargets((prev) => prev.filter((t) => t !== group));
  }, [setTargets]);

  return (
    <group ref={ref} position={position}>
      {children}
    </group>
  );
};

export default PickableGroup;
